const ID_REDUCER = "FILTER_REDUCER"

export const filterTypes = {SET_FILTER: 'SET_FILTER'+ID_REDUCER}